import { PriorityRenderer, ProbabilityBarRenderer } from "./OutlookRenderers";

export type StackedLines = { top: string; bottom: string };

/** Two-line cell for the Meeting view's stacked columns. */
export function StackedCell({ lines }: { lines: StackedLines }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
        minWidth: 0,
        lineHeight: 1.2,
      }}
    >
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        title={lines.top}
      >
        {lines.top || "–"}
      </span>
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          color: "#667085",
          fontSize: 11,
        }}
        title={lines.bottom}
      >
        {lines.bottom || "–"}
      </span>
    </div>
  );
}

/** Probability bar over the priority dot, as in their own columns. */
export function OutlookCell({
  probability,
  priority,
}: {
  probability: unknown;
  priority: unknown;
}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        minWidth: 0,
      }}
    >
      <div
        style={{ flex: 1, minHeight: 0, display: "flex", alignItems: "center" }}
      >
        <ProbabilityBarRenderer value={probability} />
      </div>
      <div
        style={{ flex: 1, minHeight: 0, display: "flex", alignItems: "center" }}
      >
        {priority ? <PriorityRenderer value={priority} /> : "–"}
      </div>
    </div>
  );
}
